import { TransformCardData } from "@/pages/commers/cards/commers.card.rating";
import { createColumnHelper } from "@tanstack/react-table";
import { eachDayOfInterval, format, isSameDay } from "date-fns";
import { ru } from "date-fns/locale";
import { useMemo } from "react";
import { DateRange } from "react-day-picker";

interface UseCommersCardColumnsProps {
  dateRange: DateRange;
}
export const useCommersCardColumns = ({ dateRange }: UseCommersCardColumnsProps) => {
  const columnHelper = createColumnHelper<TransformCardData>();

  const datesInRange = useMemo(
    () =>
      eachDayOfInterval({
        start: dateRange.from as Date,
        end: dateRange.to as Date,
      }),
    [dateRange.from, dateRange.to]
  );

  // type ColumnType = ProductAdvertisementHistoryDTO &
  //   FunnelHistoryDTO &
  //   GetProductCardEconomyResponseDTO &
  //   GetOrderHistoryForProductResponseDTO &
  //   GetProductPriceHistoryResponseDTO &
  //   GetProductRatingHistoryResponseDTO &
  //   ProductInfoDTO &
  //   ProfitInfoDTO &
  //   RatingInfoDTO;

  // type ColumnMarksType = Record<keyof ColumnType, string>;

  const columnsMarks: Record<string, string> = {
    Выручка: "₽",
    Бюджет: "₽",
    Баланс: "₽",
    Расходы: "₽",
    "Корзина → заказ, %": "%",
    "Карточка → корзина, %": "%",
    "Показ → Карточка, %": "%",
    "Чистая прибыль": "₽",
    "Чистая прибыль, %": "%",
    "Выручка, %": "%",
    Наценка: "₽",
    Цена: "₽",
    "Старая цена": "₽",
    "Цена с СПП": "₽",
    "Процент СПП": "%",
    "Цена с картой": "₽",
  };

  const createColumns = (datesArr: Date[]) => {
    const sortedDates = [...datesArr].sort((a, b) => a.getTime() - b.getTime());
    return sortedDates.map((date) => {
      const formattedDate = format(date, "dd MMMM", { locale: ru });
      return columnHelper.display({
        id: `date_${format(date, "yyyy-MM-dd")}`,
        header: formattedDate,
        minSize: 150,
        size: 150,
        enableHiding: false,
        cell: (info) => {
          const rowData = info.row.original;
          const mark = rowData.label in columnsMarks ? columnsMarks[rowData.label] : "";
          const match = rowData.data.find((entry) => {
            return isSameDay(entry.date, date) ? entry : false;
          });

          return match && match.value ? (
            <span className={`after:content-['_${mark}']`}>{Math.floor(match.value)}</span>
          ) : (
            <span>-</span>
          );
        },
      });
    });
  };

  const cardColumns = [
    columnHelper.display({
      id: "parameters",
      header: "Параметры",
      minSize: 300,
      cell(info) {
        const label = info.row.original.label;
        return <div className="w-full text-left px-2">{label}</div>;
      },
    }),

    ...createColumns(datesInRange),
  ];
  return cardColumns;
};
